export default "__VITE_ASSET__CJaCnfE1__"